/**
 * Decode HTML entities (&reg;, &trade;, &amp;, etc.) to their characters.
 * Loops until stable to handle double-encoded values (e.g. &amp;trade; -> ™).
 */
export function decodeHtmlEntities(text) {
  if (text == null || text === '') return text;
  const input = typeof text === 'string' ? text : String(text);
  if (typeof document === 'undefined') return input;

  const textarea = document.createElement('textarea');
  let decoded = input;
  let prev = '';
  let iterations = 0;
  while (decoded !== prev && iterations < 10) {
    prev = decoded;
    textarea.innerHTML = decoded;
    decoded = textarea.value;
    iterations += 1;
  }
  return decoded;
}
